var viewer_caption_rtlignore_default = {
  "fontElementMap": "SEGT-",
  "imageCaption": "cyOhj"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
